import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Bredcrumb from "../Breadcrumb/Main";
import ServiceDetails from "../Menservicedtls/ServiceDetails";
import AboutFive from "../Menservicedtls/AboutFive";
import VideoTwo from "../Menservicedtls/VideoTwo";
import ProcessThree from "../Menservicedtls/ProcessThree";
import ProcessSix from "../Menservicedtls/ProcessSix";
import TestimonialSix from "../Menservicedtls/TestimonialSix";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-1" />
            <div className="page-wrapper-bg-2" />
            <main className="site-main">
              <Bredcrumb title="Home" subtitle="SEO Services Details" />
              <ServiceDetails />
              <AboutFive />
              <VideoTwo />
              <ProcessThree />
              <ProcessSix />
              <TestimonialSix />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
